import React, { FC, ReactNode } from 'react'
import { Grid } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  main: {
    width: '100%',
    minHeight: 'calc(100vh - 112px)',
    backgroundColor: theme.palette.info.main,
    padding: '0 32px',
  },
  container: {
    maxWidth: 1376,
    margin: '0 auto',
    borderTop: '1px solid rgba(255,255,255,0.32)',
  },
}))

interface TradingProp {
  children: ReactNode
}

export const Trading: FC<TradingProp> = ({ children }) => {
  const classes = useStyles()

  return (
    <main className={classes.main}>
      <Grid item lg className={classes.container}>
        {children}
      </Grid>
    </main>
  )
}
